import React, { useEffect, useRef } from "react";
import styled from "styled-components";
import Lottie from "lottie-react";
import lottiePhoneAlarming from "src/assets/lotties/lottie_alarm_phone.json";
import lottieAlarmingBell from "src/assets/lotties/lottie_alarm_bell.json";
import SectionBg from "src/assets/images/alarm_section/img_bg_wave.png";
import chip01 from "src/assets/images/alarm_section/img_chips_01.png";
import chip02 from "src/assets/images/alarm_section/img_chips_02.png";
import chip03 from "src/assets/images/alarm_section/img_chips_03.png";
import chip04 from "src/assets/images/alarm_section/img_chips_04.png";
import chip05 from "src/assets/images/alarm_section/img_chips_05.png";
import chip06 from "src/assets/images/alarm_section/img_chips_06.png";
import chip07 from "src/assets/images/alarm_section/img_chips_07.png";
import chip08 from "src/assets/images/alarm_section/img_chips_08.png";
import chip09 from "src/assets/images/alarm_section/img_chips_09.png";
import chip10 from "src/assets/images/alarm_section/img_chips_10.png";
import chip11 from "src/assets/images/alarm_section/img_chips_11.png";

import {
    Section as StyledSection,
    Inner,
    LinePoint,
    SubLine,
    TitleLine,
    LineBreak,
} from "src/styles/common/sectionStyles";
import {mediaUnderTablet, mediaTablet,mediaLaptop, mediaPc} from "src/styles/mediaQuery";
import {motion, useInView} from "framer-motion";
import Marquee from "react-fast-marquee";

const textContainerVariants = {
    initial: {
        opacity: 0,
        y: 45
    },
    animate: {
        opacity: 1,
        y: 0,
        transition: {
            duration: .5,
            delay:.5,
        }
    },

};
const bellVariants = {
    initial: {
        opacity: 0,
        scale:0,
    },
    animate: {
        scale:1,
        opacity: 1,
        y: 0,
        transition: {
            duration: .5,
            delay:.5,
        }
    },

};

const bgVariants = {
    initial: {
        opacity: 0,
    },
    animate: {
        opacity: 1,
        transition: {
            duration: 1,
            delay:.5,
        }
    },

};
const items = [chip01, chip02, chip03, chip04, chip05, chip06, chip07, chip08, chip09, chip10, chip11];


const SlidingList: React.FC<{ inView: boolean }> = ({ inView }) => {
    return (
        <ChipsWrap
            initial={{ opacity: 0 }}
            animate={inView ? { opacity: 1 } : {}}
            transition={{ duration: 1 }}
        >
            <Marquee gradient={false} speed={50}>
                {items.map((item, index) => (
                    <ChipsItem key={index}>
                        <img src={item} alt={`chip-${index}`} />
                    </ChipsItem>
                ))}
            </Marquee>
        </ChipsWrap>
    );
};


function AlarmSectionView() {
    const ref = useRef(null);
    const lottieRef = useRef<any>(null);
    const inView = useInView(ref, { once: true, amount: 0.3 });

    useEffect(() => {
        if (inView && lottieRef.current) {
            lottieRef.current.play(); // 애니메이션 재생
        }
    }, [inView]);

    return (
        <Section ref={ref}>
            <ContentBg
                variants={bgVariants}
                initial="initial"
                animate="animate"
                viewport={{ once: true, amount: 0.35 }}
            />
            <Inner>
                <ContentsWrap>
                    <Contents
                        variants={textContainerVariants}
                        initial="initial"
                        whileInView="animate"
                        viewport={{ once: true, amount: 0.3 }}
                    >
                        <TextWrapper>
                            <TitleLine>
                                관심경품 등록하고<br />
                                <LinePoint className="main-color">이벤트 알림&nbsp;</LinePoint>
                                바로 받고
                            </TitleLine>
                            <SubLine>
                                평소에 갖고 싶은 아이템이 있나요?
                                <LineBreak className="mob" /> 이젠 경품으로 받으세요.
                                <br />
                                관련 이벤트가 등록되면 바로 알려드릴게요!
                            </SubLine>
                        </TextWrapper>
                    </Contents>
                    <Contents>
                        <SlidingList inView={inView} />
                        <ImageContainer>
                            <ImageItem
                                className="lottie lottie-alarm-bell"
                                variants={bellVariants}
                                initial="initial"
                                whileInView="animate"
                                viewport={{ once: true }}
                            >
                                <Lottie animationData={lottieAlarmingBell} loop autoPlay />
                            </ImageItem>
                            <ImageItem className="lottie lottie-phone-alarming">
                                <Lottie
                                    lottieRef={lottieRef}
                                    animationData={lottiePhoneAlarming}
                                    loop={false}
                                    autoplay={false}
                                />
                            </ImageItem>
                        </ImageContainer>
                    </Contents>
                </ContentsWrap>
            </Inner>
        </Section>
    );
}

export default AlarmSectionView;

const Section = styled(StyledSection)`
  position: relative;
  &::before {
    position: absolute;
    content: "";
    width: 30vw;
    height: 100%;
    top: 0;
    left: 0;
    z-index:5;
    background: linear-gradient(to left, rgba(255, 255, 255, 0), rgba(255, 255, 255, 1), rgba(255, 255, 255, 1));
  }

  &::after {
    position: absolute;
    content: "";
    width: 30vw;
    height: 100%;
    top: 0;
    right: 0;
    background: linear-gradient(to right, rgba(255, 255, 255, 0), rgba(255, 255, 255, 1), rgba(255, 255, 255, 1));
    z-index: 5;
  }

 ${mediaTablet} {
    &::before {
      width: 12vw;
      background: linear-gradient(to left, rgba(255, 255, 255, 0), rgba(255, 255, 255, 1));
    }

    &::after {
      width: 12vw;
      background: linear-gradient(to right, rgba(255, 255, 255, 0), rgba(255, 255, 255, 1));
    }
  }
  ${mediaUnderTablet} {
    &::before, &::after {
      display: none;
    }
  }
`
const ContentBg=styled(motion.div)`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  margin: 0 auto;
  width: 100%;
  height: 100%;
  background: url(${SectionBg}) no-repeat center / cover;
`
const ContentsWrap = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  flex-flow: column;
  justify-content: space-between;
  align-items: center;
`;
const Contents = styled(motion.div)`
  position: relative;
  &:nth-child(1) {
    text-align: center;
  }
  &:nth-child(2) {
    width: 100%;
    height: auto;
    flex-shrink: 0;
    z-index: 2;
    display: flex;
    flex-flow: column;
    align-items: center;
    justify-content: center;
    overflow: hidden;
  }
`;

const TextWrapper = styled.div`
  padding-top: 330px;
  ${mediaPc}{
    padding-top: 430px;
  }
  ${mediaLaptop} {
    text-align: center;
  }
  ${mediaTablet} {
    padding-top: unset;
  }
`;

const ImageContainer = styled.ul`
  position: relative;
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  gap: 20px;
  margin-top: 40px;
  ${mediaTablet}{
    width: 100%;
    height: auto;
    gap: 10px ;
  }
`;
const ImageItem = styled(motion.li)`
  &.lottie-alarm-bell {
    width: 113px;
    height: 97px;
    ${mediaUnderTablet}{
      width: 59px;
      height: 42px;
    }
  }

  &.lottie-phone-alarming {
    width: 354px;
    height: 730px;
    ${mediaTablet} {
      width: 306px;
      height: 630px;
    }
    ${mediaUnderTablet}{
      width: 168px;
      height: 346px;
    }
  }
`;
const ChipsWrap = styled(motion.div)`
  position: absolute;
  top: 110px;
  overflow: hidden; 
  width: 100%; 
  ${mediaUnderTablet} {
    top: 80px;
  }
  z-index: -1;
`
const ChipsItem = styled(motion.li)`
  width: 282px;
  height: 114px;
  margin-right: 10px;
  ${mediaTablet} {
    width: 240px;
    height: 97px;
  }
  ${mediaUnderTablet } {
    width: 140px;
    height: 57px;
  }
`

